import { Input } from '@/components/ui/input';
import type { MetadataSchemaField } from '@/types/metadata.types';

interface NumberFieldProps {
  field: MetadataSchemaField;
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  disabled?: boolean;
  isDecimal?: boolean;
}

export default function NumberField({
  field,
  value,
  onChange,
  error,
  disabled,
  isDecimal = false,
}: NumberFieldProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val === '') {
      onChange(null);
    } else {
      onChange(isDecimal ? parseFloat(val) : parseInt(val, 10));
    }
  };

  return (
    <Input
      id={field.fieldKey}
      type="number"
      placeholder={field.placeholder || ''}
      value={value !== null && value !== undefined ? String(value) : ''}
      onChange={handleChange}
      disabled={disabled}
      step={isDecimal ? '0.01' : '1'}
      min={field.validationRules?.min}
      max={field.validationRules?.max}
      className={error ? 'border-destructive' : ''}
    />
  );
}
